var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.286 1c-.625 0-1.143.577-1.143 1.273v1.272H0V15h16V3.545h-5.143V2.273C10.857 1.577 10.34 1 9.714 1H6.286zm0 1.273h3.428v1.272H6.286V2.273zM1.143 4.818h13.714V8h-2.286v-.636h-2.285V8H5.714v-.636H3.43V8H1.143V4.818zm0 4.455h2.286v.636h2.285v-.636h4.572v.636h2.285v-.636h2.286v4.454H1.143V9.273z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.948c15805009e26f1b71eaa863048d90.svg";
export { ForwardRef as ReactComponent };